<template>
  <div class="page-card about">
    <h1 class="page-title">About LearnNow</h1>

    <div class="about-intro">
      <p class="abouttext">
        <strong>LearnNow</strong> helps everyone strengthen essential literacy and quantitative skills - whether
        preparing for a job assessment, improving English proficiency, or maintaining everyday skills.
      </p>
      <p class="abouttext">
        All activities are self-paced and run in your browser with no installation required. Work on
        any device and resume where you left off.
      </p>
    </div>

    <div class="about-grid">
      <div class="about-card">
        <div class="about-card__icon">🔤</div>
        <h3 class="about-card__title">Verbal</h3>
        <p class="about-card__body">
          Practice core verbal skills: vocabulary building, spelling, word
          recognition, and word search across graded difficulty levels.
        </p>
      </div>
      <div class="about-card">
        <div class="about-card__icon">🔢</div>
        <h3 class="about-card__title">Quantitative</h3>
        <p class="about-card__body">
          Practical quantittive: arithmetic, fractions, sequences, times tables, and shape recognition
          with configurable difficulty.
        </p>
      </div>
      <div class="about-card">
        <div class="about-card__icon">🧮</div>
        <h3 class="about-card__title">Tools</h3>
        <p class="about-card__body">
          Interactive practice tools and a calculator with optional challenge modes to build fluency.
        </p>
      </div>
      <div class="about-card">
        <div class="about-card__icon">🎨</div>
        <h3 class="about-card__title">Colours</h3>
        <p class="about-card__body">
          Colour recognition exercises and a focused quiz to build visual discrimination skills.
        </p>
      </div>
    </div>

    <div class="about-values">
      <h2 class="about-values__title">Why LearnNow?</h2>
      <ul class="about-values__list">
        <li><strong>Flexible pacing</strong> - learn at the speed that fits your schedule.</li>
        <li><strong>Tiered difficulty</strong> - progression from foundational practice to advanced challenges.</li>
        <li><strong>Immediate feedback</strong> - clear, actionable responses to each answer.</li>
        <li><strong>Progress tracking</strong> - monitor performance and improvements over time.</li>
        <li><strong>Cross-platform</strong> - accessible from desktop, tablet, or mobile with no installation.</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.about {
  max-width: 900px;
  margin: 0 auto;
}

.about-intro {
  margin-bottom: 2rem;
  border-bottom: 1px solid var(--color-border);
  padding-bottom: 1.5rem;
}

.abouttext {
  font-size: 1.1rem;
  line-height: 1.85;
  color: var(--color-text);
  margin: 0 0 1rem;
}

.abouttext:last-child { margin-bottom: 0; }

/* Feature grid */
.about-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 1rem;
  margin-bottom: 2rem;
}

.about-card {
  background: var(--color-surface-solid);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  padding: 1.25rem 1rem;
  text-align: center;
}

.about-card__icon {
  font-size: 2rem;
  margin-bottom: 0.5rem;
}

.about-card__title {
  font-size: 1rem;
  font-weight: 700;
  margin: 0 0 0.5rem;
  color: var(--color-primary-dark);
}

.about-card__body {
  font-size: 0.88rem;
  color: var(--color-text-muted);
  line-height: 1.6;
  margin: 0;
}

/* Values */
.about-values {
  background: var(--color-primary-light);
  border-radius: var(--radius-md);
  padding: 1.5rem;
}

.about-values__title {
  font-size: 1.2rem;
  margin: 0 0 1rem;
  color: var(--color-primary-dark);
}

.about-values__list {
  padding-left: 1.25rem;
  margin: 0;
}

.about-values__list li {
  font-size: 1rem;
  line-height: 1.8;
  color: var(--color-text);
  margin-bottom: 0.25rem;
}
</style>
